import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'
import { cleaned_title, getCleanedString } from '../../utils/utilities'

export function initializeUtagEvents() {
  on({
    eventName: 'click',
    selector: '.utag-entertainment-link',
    handler() {
      const fhiPageType = document.querySelector('html')?.dataset?.fhiTest
      const isFhiPage = fhiPageType !== undefined
      const eventLabel = this.closest('.utag-information-module')?.dataset?.utagBlockTitle || ''
      const cardTitle = this.closest('.utag-information-module')?.dataset?.utagCardTitle || ''

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat: 'information module',
          event_act: getCleanedString(eventLabel || ''),
          event_lbl: cleaned_title(cardTitle || ''),
          event_purpose: 'information',
          event_structure: 'body',
          ...(isFhiPage ? { page_variation: fhiPageType } : {}),
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.utag-information-module-book-now',
    handler() {
      const fhiPageType = document.querySelector('html')?.dataset?.fhiTest
      const isFhiPage = fhiPageType !== undefined

      sendUtagEvent({
        data: {
          event_name: 'searcher_hotel',
          event_cat: 'searcher',
          event_act: 'scroll to fastbooking',
          event_lbl: 'popup',
          event_purpose: 'booking',
          event_structure: 'sticky',
          ...(isFhiPage ? { page_variation: fhiPageType } : {}),
        },
      })
    },
    once: true,
  })

  on({
    eventName: 'click',
    selector: '.utag-navegation-modal-videos-prev',
    handler(e) {
      const blockTitle =
        e.target.closest('.modal__content')?.querySelector('[data-block-title]')?.dataset?.blockTitle || ''
      const cardTitle =
        e.target.closest('.modal__content')?.querySelector('.swiper-slide-active .video-content')?.dataset
          ?.utagCardTitle || ''

      const orderSlide = e.target.closest('.modal__content')?.querySelector('.swiper-slide-prev .video-content')
        ?.dataset?.orderSlide
      const numSlide = orderSlide ? parseInt(orderSlide, 10) + 1 : 0

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat: 'information module',
          event_act: getCleanedString(blockTitle || ''),
          event_lbl: getCleanedString(cardTitle || '') || numSlide,
          event_purpose: 'information',
          event_structure: 'popup',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.utag-navegation-modal-videos-next',
    handler(e) {
      const blockTitle =
        e.target.closest('.modal__content')?.querySelector('[data-block-title]')?.dataset?.blockTitle || ''
      const cardTitle =
        e.target.closest('.modal__content')?.querySelector('.swiper-slide-active .video-content')?.dataset
          ?.utagCardTitle || ''
      const orderSlide = e.target.closest('.modal__content')?.querySelector('.swiper-slide-next .video-content')
        ?.dataset?.orderSlide
      const numSlide = orderSlide ? parseInt(orderSlide, 10) + 1 : 0

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat: 'information module',
          event_act: getCleanedString(blockTitle || ''),
          event_lbl: getCleanedString(cardTitle || '') || numSlide,
          event_purpose: 'information',
          event_structure: 'popup',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.utag-trigger-modal-videos',
    handler(e) {
      const blockTitle = e.target.closest('.utag-information-module')?.dataset?.utagBlockTitle || ''
      const cardTitle = e.target.closest('.utag-information-module')?.dataset?.utagCardTitle || ''

      const orderSlide = e.target.closest('.utag-information-module')?.querySelector('.video-content')
        ?.dataset?.orderSlide
      const numSlider = orderSlide ? parseInt(orderSlide, 10) + 1 : 0

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat: 'information module',
          event_act: getCleanedString(blockTitle || ''),
          // 🛑 FIX AQUÍ: Se añade || '' a cardTitle para evitar pasar undefined a getCleanedString
          event_lbl: getCleanedString(cardTitle || '') || numSlider,
          event_purpose: 'information',
          event_structure: 'body',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.information-modules .utag-see-more-link',
    handler() {
      const element = this
      const utagBlockTitle = element.closest('.info-items')?.dataset?.utagBlockTitle || ''
      const utagCardTitle = element.closest('[data-utag-card-title]')?.dataset?.utagCardTitle || ''

      const event_cat = 'information module'
      const event_act = cleaned_title(utagBlockTitle || '')
      const event_lbl = utagCardTitle

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat,
          event_act: getCleanedString(event_act || ''),
          event_lbl: getCleanedString(event_lbl || ''),
          event_purpose: 'information',
          event_structure: 'body',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.info-items .content .text a',
    handler() {
      const element = this
      const blockTitle = element.closest('.utag-information-module')?.dataset?.utagBlockTitle || ''
      const cardTitle = element.closest('.utag-information-module')?.dataset?.utagCardTitle || ''
      const event_cat = 'information module'
      const event_act = cleaned_title(blockTitle || '')
      const event_lbl = cardTitle

      sendUtagEvent({
        data: {
          event_name: 'information_module',
          event_cat,
          event_act: getCleanedString(event_act || ''),
          event_lbl: getCleanedString(event_lbl || ''),
          event_purpose: 'information',
          event_structure: 'body',
        },
      })
    },
  })
}
